import { render, staticRenderFns } from "./Shopware6.vue?vue&type=template&id=0e23e7be&"
import script from "./Shopware6.vue?vue&type=script&lang=js&"
export * from "./Shopware6.vue?vue&type=script&lang=js&"
import style0 from "./Shopware6.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports